import React from 'react';
export function SocialProofBar() {
  return <section className="w-full bg-[#001a2d] py-12 px-4" data-id="element-325">
      <div className="max-w-5xl mx-auto" data-id="element-326">
        {/* Stats */}
        <div className="grid grid-cols-2 sm:grid-cols-5 gap-6 mb-12 text-center" data-id="element-327">
          <div data-id="element-328">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-329">
              +500
            </div>
            <div className="text-[#00B4D8] text-sm font-semibold mt-1" data-id="element-330">
              docentes confían
            </div>
          </div>
          <div data-id="element-331">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-332">6</div>
            <div className="text-[#00B4D8] text-sm font-semibold mt-1" data-id="element-333">
              Tomos listos
            </div>
          </div>
          <div data-id="element-334">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-335">6</div>
            <div className="text-[#00B4D8] text-sm font-semibold mt-1" data-id="element-336">
              Bonos incluidos
            </div>
          </div>
          <div data-id="element-337">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-338">
              4.9/5
            </div>
            <div className="text-[#00B4D8] text-sm font-semibold mt-1" data-id="element-339">
              calificación ⭐
            </div>
          </div>
          <div data-id="element-340">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-341">🇦🇷</div>
            <div className="text-[#00B4D8] text-sm font-semibold mt-1" data-id="element-342">
              Todo el país
            </div>
          </div>
        </div>

        {/* Micro testimonials */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-343">
          <div className="flex items-start gap-3 bg-black/40 border border-[#00B4D8]/20 rounded-xl p-4" data-id="element-344">
            <div className="w-10 h-10 rounded-full bg-[#00B4D8]/20 flex items-center justify-center text-[#00B4D8] font-black text-sm flex-shrink-0" data-id="element-345">
              MG
            </div>
            <div data-id="element-346">
              <div className="text-[#00B4D8] text-xs mb-1" data-id="element-347">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-348">
                "Organicé todo el año de Francés en una tarde. Nunca más llegué
                sin material al aula. Mis alumnos no pueden creer que aprendan
                tanto en cada clase. El solucionario me ahorra horas cada
                semana. El passé composé por fin se entiende."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-349">
                — Mariela G., Córdoba | Docente de Francés Secundaria
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#00B4D8]/20 rounded-xl p-4" data-id="element-350">
            <div className="w-10 h-10 rounded-full bg-[#00B4D8]/20 flex items-center justify-center text-[#00B4D8] font-black text-sm flex-shrink-0" data-id="element-351">
              LP
            </div>
            <div data-id="element-352">
              <div className="text-[#00B4D8] text-xs mb-1" data-id="element-353">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-354">
                "Las actividades están perfectamente pensadas para el alumno
                argentino que aprende francés. Los tomos de gramática visual son
                el hit de la clase. El subjonctif por fin se entiende y mis
                alumnos lo usan sin miedo."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-355">
                — Laura P., Rosario | Docente de Francés Instituto de Idiomas
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#00B4D8]/20 rounded-xl p-4" data-id="element-356">
            <div className="w-10 h-10 rounded-full bg-[#00B4D8]/20 flex items-center justify-center text-[#00B4D8] font-black text-sm flex-shrink-0" data-id="element-357">
              RM
            </div>
            <div data-id="element-358">
              <div className="text-[#00B4D8] text-xs mb-1" data-id="element-359">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-360">
                "Nunca más llegué sin material. Mis clases de B1 sobre cultura
                francesa por fin enganchan de verdad. El tomo de produción oral
                y debate es increíble. Vale cada peso invertido."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-361">
                — Roberto M., Buenos Aires | Docente de Francés Secundaria +
                Instituto
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}